import React from 'react';

import Facebook from '../icons/facebook-quote.svg';
import SmartWatch from '../icons/smartwatch.svg';
import IconLink from '../icons/link.svg';

function PageArticleIcon({ icon }) {
  if (icon === 'facebook') {
    return <Facebook />;
  }
  if (icon === 'smartwatch') {
    return <SmartWatch />;
  }
  if (icon === 'link') {
    return <IconLink />;
  }

  return false;
}

export default PageArticleIcon;
